// extracted by mini-css-extract-plugin
export var card = "_wd-0";